// Daily Traffic Dashboards Default

export const path = { "default": 'Report', "booking": "Booking", "products": "Products", "customer": "Customer","pooja-bookings": "Pooja Bookings","poojas": "Poojas" };

export const barChartDataDailyTraffic = [
  {
    name: "Daily Sales",
    data: [20, 30, 40, 20, 45, 50],
  },
];

export const barChartOptionsDailyTraffic = {
  chart: {
    toolbar: {
      show: false,
    },
  },
  tooltip: {
    style: {
      fontSize: "12px",
      fontFamily: undefined,
    },
    onDatasetHover: {
      style: {
        fontSize: "12px",
        fontFamily: undefined,
      },
    },
    theme: "dark",
  },
  xaxis: {
    categories: ["12", "13", "14", "15", "16", "17"],
    show: false,
    labels: {
      show: true,
      style: {
        colors: "#A3AED0",
        fontSize: "14px",
        fontWeight: "500",
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    show: false,
    color: "black",
    labels: {
      show: true,
      style: {
        colors: "#CBD5E0",
        fontSize: "14px",
      },
    },
  },
  grid: {
    show: false,
    strokeDashArray: 5,
    yaxis: {
      lines: {
        show: true,
      },
    },
    xaxis: {
      lines: {
        show: false,
      },
    },
  },
  fill: {
    type: "gradient",
    gradient: {
      type: "vertical",
      shadeIntensity: 1,
      opacityFrom: 0.7,
      opacityTo: 0.9,
      colorStops: [
        [
          {
            offset: 0,
            color: "#4318FF",
            opacity: 1,
          },
          {
            offset: 100,
            color: "rgba(67, 24, 255, 1)",
            opacity: 0.28,
          },
        ],
      ],
    },
  },
  dataLabels: {
    enabled: false,
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      columnWidth: "40px",
    },
  },
};

// Consumption Users Reports

export const barChartDataConsumption = [
  {
    name: "Agarbathi  ",
    data: [420, 390, 360, 400, 370, 380, 395,],
  },
  {
    name: "Camphor",
    data: [300, 280, 260, 290, 275, 285, 295,],
  },
  {
    name: "Puja Oil ",
    data: [350, 330, 310, 340, 320, 335, 345,],
  },
  {
    name: "Flowers  ",
    data: [500, 480, 460, 490, 470, 485, 495,],
  },
  {
    name: "Coconut",
    data: [450, 430, 420, 440, 425, 435, 445,],
  },
  {
    name: "Kumkum",
    data: [200, 190, 180, 195, 185, 192, 198,],
  },
  {
    name: "Vibhuti  ",
    data: [220, 210, 200, 215, 205, 212, 218,],
  },
  {
    name: "Puja Bells",
    data: [150, 140, 130, 145, 135, 142, 148, ],
  },
  {
    name: "Cotton Wicks ",
    data: [280, 265, 250, 270, 260, 268, 275, ],
  },
  {
    name: "Prasadam Containers",
    data: [180, 170, 160, 175, 165, 172, 178, ],
  },
];

export const barChartOptionsConsumption = {
  chart: {
    stacked: true,
    toolbar: {
      show: false,
    },
  },

  tooltip: {
    theme: "dark",
    y: {
      formatter: (val) => `${val} units`,
    },
  },

  xaxis: {
    categories: ["9", "10", "11", "12", "13", "14", "15"],
    labels: {
      show: true,
      style: {
        colors: "#A3AED0",
        fontSize: "13px",
        fontWeight: "500",
      },
    },
    axisBorder: { show: false },
    axisTicks: { show: false },
  },

  yaxis: {
    labels: {
      show: false,
    },
  },

  grid: {
    borderColor: "rgba(163, 174, 208, 0.2)",
    yaxis: { lines: { show: false } },
    xaxis: { lines: { show: false } },
  },

  plotOptions: {
    bar: {
      borderRadius: 6,
      columnWidth: "35%",
    },
  },

  dataLabels: {
    enabled: false,
  },

  /* ✅ 10 COLORS FOR 10 TEMPLE PRODUCTS */
  colors: [
    "#FF6B6B", // Agarbathi
    "#FFD93D", // Camphor
    "#6BCB77", // Deepam Oil
    "#4D96FF", // Flowers
    "#9D4EDD", // Coconut
    "#F9844A", // Kumkum
    "#90DBF4", // Vibhuti
    "#FFAFCC", // Bells
    "#CDB4DB", // Cotton Wicks
    "#B7E4C7", // Prasadam Containers
  ],

  legend: {
    show: true,
    position: "bottom",
    labels: {
      colors: "#A3AED0",
    },
  },

  fill: {
    type: "solid",
  },
};


export const pieChartOptions = {
  labels: ["Your files", "System", "Empty"],
  colors: ["#4318FF", "#6AD2FF", "#EFF4FB"],
  chart: {
    width: "50px",
  },
  states: {
    hover: {
      filter: {
        type: "none",
      },
    },
  },
  legend: {
    show: false,
  },
  dataLabels: {
    enabled: false,
  },
  hover: { mode: null },
  plotOptions: {
    donut: {
      expandOnClick: false,
      donut: {
        labels: {
          show: false,
        },
      },
    },
  },
  fill: {
    colors: ["#4318FF", "#6AD2FF", "#EFF4FB"],
  },
  tooltip: {
    enabled: true,
    theme: "dark",
  },
};

export const pieChartData = [63, 25, 12];

// Total Spent Default

export const lineChartDataTotalSpent = [
  {
    name: "Revenue",
    data: [50, 64, 48, 66, 49, 68],
  },
  {
    name: "Profit",
    data: [30, 40, 24, 46, 20, 46],
  },
];

export const lineChartOptionsTotalSpent = {
  chart: {
    toolbar: {
      show: false,
    },
    dropShadow: {
      enabled: true,
      top: 13,
      left: 0,
      blur: 10,
      opacity: 0.1,
      color: "#4318FF",
    },
  },
  colors: ["#4318FF", "#39B8FF"],
  markers: {
    size: 0,
    colors: "white",
    strokeColors: "#7551FF",
    strokeWidth: 3,
    strokeOpacity: 0.9,
    strokeDashArray: 0,
    fillOpacity: 1,
    discrete: [],
    shape: "circle",
    radius: 2,
    offsetX: 0,
    offsetY: 0,
    showNullDataPoints: true,
  },
  tooltip: {
    theme: "dark",
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "smooth",
    type: "line",
  },
  xaxis: {
    type: "numeric",
    categories: ["SEP", "OCT", "NOV", "DEC", "JAN", "FEB"],
    labels: {
      style: {
        colors: "#A3AED0",
        fontSize: "12px",
        fontWeight: "500",
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    show: false,
  },
  legend: {
    show: false,
  },
  grid: {
    show: false,
    column: {
      color: ["#7551FF", "#39B8FF"],
      opacity: 0.5,
    },
  },
  color: ["#7551FF", "#39B8FF"],
};
